import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import Slider from '@mui/material/Slider'
import { Input } from './Input'
import '../../globals/scss/components/slider.scss'

// TODO: Ignore Number field
export const RangeSlider = forwardRef(
  ({ addonBefore, addonAfter, marks, value, error, ...props }, ref) => {
    return (
      <div className="d-flex flex-column gap-y-2">
        <div className="rangeSlider">
          <div className="rangeSlider__sliderWrapper">
            <span className="left-val">{addonBefore}</span>
            <Slider
              ref={ref}
              marks={marks}
              valueLabelDisplay="auto"
              value={Number(value)}
              {...props}
            />
            <span className="right-val">{addonAfter}</span>
          </div>

          <div className="rangeSlider__inputWrapper inputGroup">
            <Input ref={ref} type="number" value={value} {...props} />
          </div>
        </div>

        {error && <span className="input-error is-visible">{error}</span>}
      </div>
    )
  },
)

RangeSlider.displayName = 'RangerSlider'

RangeSlider.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any.isRequired,
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  addonBefore: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.arrayOf(PropTypes.element),
  ]),
  addonAfter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.arrayOf(PropTypes.element),
  ]),
  marks: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    ),
  ]),
  disabled: PropTypes.bool,
  error: PropTypes.string,
}

RangeSlider.defaultProps = {
  name: 'slider',
  min: 0,
  max: 100,
  step: 1,
}
